// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"7c42f75d","316":"aa42a990","393":"2a988557","444":"82ec82d4","466":"b1e484d3","612":"d1cadb87","642":"4ca489da","684":"5a51f535","776":"1479dc69","945":"2589a10a","961":"4d6d88a4","971":"91e9400e"}[chunkId] + ".chunk.js";
};